export default class Navigation {
    constructor(options) {
        this.options = {
            ...{
                selector: '.desktop-navigation, .mobile-navigation',
                activeClass: 'active',
                dropdownSelector: '.dropdown'
            },
            ...this.options
        };
        document.addEventListener('DOMContentLoaded', () => { this.init(); });
    }
    init() {
        this.setActive();
    }
    setActive() {
        var navList = document.querySelectorAll(this.options.selector);
        for (var i = 0; i < navList.length; i += 1) {
            var linkList = navList[i].querySelectorAll('li a');
            for (var q = 0; q < linkList.length; q += 1) {
                let url = linkList[q].getAttribute('href') ? linkList[q].getAttribute('href').toLowerCase() : "";
                let currentUrl = location.pathname.toLowerCase();
                if (url == currentUrl) {
                    this.toggleAncestor(linkList[q].parentElement, true);
                    linkList[q].parentElement.classList.add(this.options.activeClass);
                }
            }
        }
    }
    toggleAncestor(el, recursive = false) {
        this.options.debug && console.log("toggleAncestor", el, "Recursive: " + recursive);
        var ancestor = el.closest(this.options.dropdownSelector);
        this.options.debug && (ancestor != null ? console.log("Ancestor found: ", ancestor) : console.log("Ancestor not found"));
        if (ancestor !== null) {
            ancestor.classList.add(this.options.activeClass);
            recursive && this.toggleAncestor(ancestor.parentElement, true);
        }
    }
}
